module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHBAMAAADOnLEXAAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACHRSTlMA8DeoGQPnoowBipkAAAAxSURBVAjXY3ArZWAIT2FwbA5gtRBhYJIwDW5UYGBQbLYQYmAAckEcIBfIAQIWBwYGAMZjBj9dqvjGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/whiteDown.png
// module id = 1L9/
// module chunks = 1